// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.noMarginForForm[data-v-23810a54]{\r\n  padding:25px !important;\n}\r\n\r\n", ""]);
// Exports
module.exports = exports;
